var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarehouseIntelligence = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "WarehouseIntelligence_svg__Crop_Marks",
  viewBox: "0 0 48 48"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".WarehouseIntelligence_svg__cls-4{fill:none;stroke-miterlimit:10;stroke-width:1.5px;stroke:#dde0e8}"))), /*#__PURE__*/React.createElement("g", {
  id: "WarehouseIntelligence_svg__Group_57685"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Path_97027",
  d: "M7.78 35.24V12.65l16.58-7.08 16.57 6.54v23.13",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2083",
  d: "M4.23 36.51h39.34",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2084",
  d: "M9.7 14.88h29.32",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2085",
  d: "M21.9 17.24h4.94",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2086",
  d: "m6.23 42.43 8.12-3.7",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2087",
  d: "m5.18 39.61 1.95-.88",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2088",
  d: "m41.84 42.43 1.93-.89",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2089",
  d: "m13.24 42.43 8.13-3.7",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2090",
  d: "m20.32 42.43 8.13-3.7",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2091",
  d: "m27.33 42.43 8.13-3.7",
  className: "WarehouseIntelligence_svg__cls-4"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Line_2092",
  d: "m34.53 42.43 8.12-3.7",
  className: "WarehouseIntelligence_svg__cls-4"
})), /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Path_97028",
  d: "M11.37 33.97v-3.45h5.37v3.45",
  style: {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    stroke: "#119bf9"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Path_97029",
  d: "M20.48 33.97v-3.45h5.36v3.45",
  style: {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    stroke: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "WarehouseIntelligence_svg__Path_97030",
  d: "M11.41 27.79v-3.46h5.37v3.46",
  style: {
    stroke: "#a8c4cc",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px"
  }
})));
export default SvgWarehouseIntelligence;